module.exports = __webpack_public_path__ + "static/media/training-video-french.348c839f.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/training-video-french.png
// module id = 596
// module chunks = 0